﻿window.cBuilderFormulaire = function (bddRef, $iFrame, onValueChangedDevexpress) {
    var Me = this

    var indexDevExpress = 0
    this.mGetNewIndexDevexpress = function () {
        indexDevExpress += 1
        return indexDevExpress
    }

    this.mInitIframe = function (funcFin) {
        const doc = $iFrame[0].contentDocument;
        const win = $iFrame[0].contentWindow;

        if (!win.parametre) win.parametre = window.parametre;

        const addStyle = function (id, css) {
            if (doc.getElementById(id)) return; // déjà là
            const s = doc.createElement("style");
            s.id = id;
            s.textContent = css;
            doc.head.appendChild(s);
        };

        // Ajoute une balise <link> générique (preconnect, stylesheet...)
        const addLink = function (href, rel, crossorigin) {
            if (doc.querySelector('link[rel="' + rel + '"][href="' + href + '"]')) return; // déjà là
            const l = doc.createElement("link");
            l.rel = rel;
            l.href = href;
            if (crossorigin !== undefined) l.crossOrigin = crossorigin; // "" => attribut crossorigin (anonymous)
            doc.head.appendChild(l);
        };

        const addCss = function (href) {
            if (doc.querySelector('link[href="' + href + '"]')) return; // déjà là
            const l = doc.createElement("link");
            l.rel = "stylesheet";
            l.href = href;
            doc.head.appendChild(l);
        };

        const addJs = function (src, dejaLa, suite, crossorigin) {
            if (dejaLa || doc.querySelector('script[src="' + src + '"]')) return suite ? suite() : undefined; // déjà là
            const s = doc.createElement("script");
            s.src = src;
            if (crossorigin !== undefined) s.crossOrigin = crossorigin;
            if (suite) s.onload = suite;
            doc.head.appendChild(s);
        };

        addLink("https://fonts.googleapis.com", "preconnect");
        addLink("https://fonts.gstatic.com", "preconnect", "");
        addCss("https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@100;200;300;400;500;600;700;800;900&display=swap");
        // Font Awesome (kit) : se charge de façon indépendante, pas besoin d'attendre
        addJs("https://kit.fontawesome.com/9d97ffa917.js", false, null, "anonymous");;

        addCss("https://cdn3.devexpress.com/jslib/24.1.4/css/dx.light.css", false, null, "anonymous");
        addCss(parametre.urldispatch + "/js/plugin/intTel/intlTelInput.css", false, null, "anonymous");

        //addJs("https://code.jquery.com/jquery-3.7.1.min.js", win.jQuery, function () {
        //    addJs("https://cdn3.devexpress.com/jslib/24.1.4/js/dx.all.js", win.DevExpress, function () {
        //        addJs(parametre.urldispatch + "/js/dxCtrl/edit/dxCtrlTextEmail.js", win.DevExpress, function () {
        //            addJs(parametre.urldispatch + "/js/dxCtrl/edit/dxCtrlTelephone.js", win.DevExpress, function () {
        //                addJs(parametre.urldispatch + "/js/dxCtrl/dxCtrlUtils.js", win.DevExpress, function () {
        //                    addJs(parametre.urldispatch + "/js/dxCtrl/edit/adrpostale/dxCtrlSaisieAdresse.js", win.DevExpress, function () {
        //                        addJs(parametre.urldispatch + "/js/dxCtrl/tooltip/dxCtrlTooltip.js", win.DevExpress, function () {
        //                            Me.mAddCtrlDevExpress()
        //                            if (funcFin) funcFin()
        //                        });
        //                    });
        //                });
        //            });
        //        });
        //    });
        //});
        Me.mAddAllCtrlDevExpress()
        if (funcFin) funcFin()
    }
    var lstCtrlDevexpress = []
    this.mAddAllCtrlDevExpress = function () {
        //on rajoute les ctrldevexpress
        lstCtrlDevexpress = []
        indexDevExpress = 0
        $iFrame.contents().find(".eledevexpress").each(function (index, element) {
            var $EleWidget = $($(element).closest(".widget"))
            if (indexDevExpress < parseInt($(element).attr("indexdevexpress"))) indexDevExpress = parseInt($(element).attr("indexdevexpress"))

            Me.mAddCtrlDevExpress($EleWidget)
            //var cl = new window[nomClassWidget]({
            //    bddCtrl: bddRef,
            //    element: $EleWidget
            //})
            //cl.mAddCtrlDevExpress(onValueChangedDevexpress)
        })
    }

    this.mAddCtrlDevExpress = function (eleWidget) {
        var nomClassWidget = eleWidget.attr("classwidget")
        var cl = new window[nomClassWidget]({
            bddCtrl: bddRef,
            element: eleWidget
        })
        var ctrl = cl.mAddCtrlDevExpress(_onValueChangedDevexpress)
        if (ctrl) lstCtrlDevexpress.push(ctrl)
    }

    function _onValueChangedDevexpress(ctrl, index, tri, typeDevexpress, typeCtrlSelectDevexpress, typChamp, titre, value) {
        onValueChangedDevexpress(ctrl, lstCtrlDevexpress, index, tri, typeDevexpress, typeCtrlSelectDevexpress, typChamp, titre, value)
    }

    this.mInitWithData = function (dataJson) {
        if (dataJson && dataJson.lst) {
            dataJson.lst.forEach(function (itemData) {
                switch (itemData.typeDevexpress) {
                    case "dxTextBox":
                    case "dxCheckBox":
                    case "dxDateBox":
                    case "dxNumberBox":
                    case "dxTextArea":
                        var dxCtrl = $($iFrame.contents().find("div.ctrldevexpress.electrl" + itemData.index))[itemData.typeDevexpress]("instance")
                        dxCtrl.option("value", itemData.value)
                        break;
                    case "dxCtrlSaisieAdresse":
                    case "dxCtrlTextEmail":
                        var dxCtrl = $($iFrame.contents().find("div.ctrldevexpress.electrl" + itemData.index)).getInstance()
                        dxCtrl.option("value", itemData.value)
                        break;
                    case "dxCtrlTelephone":
                        var dxCtrl = $($iFrame.contents().find("div.ctrldevexpress.electrl" + itemData.index)).getInstance()
                        dxCtrl.mSetValue(itemData.value)
                        break;
                    case "dxSelect":
                        var dxCtrl = null;
                        switch (itemData.typeCtrlSelectDevexpress) {
                            case "dxList":
                                dxCtrl = $($iFrame.contents().find("div.ctrldevexpress.electrl" + itemData.index))[itemData.typeCtrlSelectDevexpress]("instance")
                                dxCtrl.option("selectedItems", itemData.value)
                                break;
                            case "dxRadioGroup":
                                dxCtrl = $($iFrame.contents().find("div.ctrldevexpress.electrl" + itemData.index))[itemData.typeCtrlSelectDevexpress]("instance")
                                dxCtrl.option("value", itemData.value[0])
                                break;
                            case "dxTagBoxClose":
                            case "dxTagBoxOpen":
                                dxCtrl = $($iFrame.contents().find("div.ctrldevexpress.electrl" + itemData.index))["dxTagBox"]("instance")
                                dxCtrl.option("value", itemData.value)
                                break;
                            case "dxSelectBoxClose":
                            case "dxSelectBoxOpen":
                                dxCtrl = $($iFrame.contents().find("div.ctrldevexpress.electrl" + itemData.index))["dxSelectBox"]("instance")
                                dxCtrl.option("value", itemData.value[0])
                                break;
                            default:
                                try {
                                    throw new Error(itemData.type + " non implémenté " + JSON.stringify(itemData));
                                } catch (e) {
                                    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                                }
                                break;
                        }
                        break;
                    default:
                        try {
                            throw new Error(itemData.type + " non implémenté " + JSON.stringify(itemData));
                        } catch (e) {
                            mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                        }
                        break;
                }
            })
        }
    }

    this.hasCtrlSaisie = function () {
        return $iFrame.contents().find(".eledevexpress").length > 0
    }
}